'use strict';

import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {observer} from "mobx-react";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import Broken from "@uw-it-sis/lib-react/lib/Broken";
import {normalize} from "@uw-it-sis/lib-react-myplan/lib/CourseUtils";
import UnknownState from "@uw-it-sis/lib-react/lib/UnknownState";
import RelatedLinks from "@uw-it-sis/lib-react-myplan/lib/RelatedLinks";
import LinkBuilder from '@uw-it-sis/lib-react-myplan/lib/LinkBuilder';

import Button from 'react-bootstrap/Button';
import Spinner from "react-bootstrap/Spinner";

import bookmarksPageStore from './BookmarksPageStore';
import Course from './Course';

/**
 * Course Bookmarks page.
 */
class Bookmarks extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = bookmarksPageStore;
        this.handleLoginClick = this.handleLoginClick.bind(this);
    }

    componentDidMount() {
        document.title = "Course Bookmarks - MyPlan";
        this.store.mount();
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    componentDidUpdate(prevProps) {
        //  Add Course Summary links/popovers to Course Requisites.
        LinkBuilder.linkifyDocument(document, "Course-Bookmark-Course-Requisite");
    }

    /**
     * Handler for the login link for unauth'd users.
     */
    handleLoginClick = () => appStore.doLogin();

    render() {
        switch (this.store.state) {
            // This one handles loading within the main component.
            case States.pending:
            case States.initial:
                return (
                    <Spinner animation="dots" role="status">
                        <span className="sr-only">Loading Course Bookmarks...</span>
                    </Spinner>
                );
            case States.error:
                return <Broken name="Bookmarks"/>;
            case States.done:
                // Proceed.
                break;
            default:
                return <UnknownState name="Bookmarks"/>;
        }

        let bookmarksWidget = null;
        const bookmarkedCourses = this.store.courses;

        if ( bookmarkedCourses.length > 0 ) {
            // Build widgets from the list of courses.
            const courseList = bookmarkedCourses.map(function (course, index) {
                return (
                    <Course key={index} course={course} courseMessage={this.store.courseMessages[normalize(course.code)]} plannedCourses={this.store.plannedCourses}/>
                )
            }, this);

            bookmarksWidget =
                <div id="course-bookmarks" data-bookmark-count={bookmarkedCourses.length}>
                    <ul className="list-unstyled d-grid gap-3">
                        {courseList}
                    </ul>
                </div>;
        } else {
            if (appStore.isAuthenticated()) {
                bookmarksWidget =
                    <div id="course-bookmarks" data-bookmark-count={bookmarkedCourses.length}>
                        <p>Your list is empty. <Link to={'/'}>Explore Courses</Link> and bookmark them to your list.</p>
                        <ul>
                            <li>Save courses of interest.</li>
                            <li>Share your list with advisers.</li>
                        </ul>
                    </div>;
            } else {
                bookmarksWidget =
                    <Button id="sign-in" variant="inline-link" onClick={this.handleLoginClick}>
                        Sign in to bookmark courses.
                    </Button>
            }
        }

        return (
            <>
                <div className="page-heading">
                    <h1>Bookmarked Courses</h1>
                </div>
                {bookmarksWidget}
                <RelatedLinks links={[{label: "Explore Courses", href: "/"}]} />
            </>
        );
    }
}

export default observer(Bookmarks);